import {
  GET_AUTHENTICATION_DETAILS,
  SET_AUTHENTICATION_DETAILS,
  SET_AUTHENTICATION_DETAILS_LOADING,
} from "./types";

export default (state, action) => {
  switch (action.type) {
    case SET_AUTHENTICATION_DETAILS:
      return {
        ...state,
        authenticated: action.payload,
        authenticatedLoading: false,
      };
    case GET_AUTHENTICATION_DETAILS:
      return {
        ...state,
        authenticated: state.authenticated,
        authenticatedLoading: false,
      };
    case SET_AUTHENTICATION_DETAILS_LOADING:
      return {
        ...state,
        authenticatedLoading: true,
      };
    default:
      return state;
  }
};
